module.exports = __webpack_public_path__ + "img/transfer-notes-icon.c0161941.svg";